var exports = {
  "Gt": "ForwardDestinationIcon.module__frame___T3BBTm",
  "z5": "ForwardDestinationIcon.module__cutout___T3BBTm",
  "qS": "ForwardDestinationIcon.module__badge___T3BBTm",
  "rF": "ForwardDestinationIcon.module__badgeIcon___T3BBTm",
  "YQ": "ForwardDestinationIcon.module__fallbackIcon___T3BBTm",
};

module.exports = exports;
